<template>
  <div>
    <search-form v-if="activePage[0] === true" @searchMade="showResults"></search-form>
    <search-results v-if="activePage[1] === true" :results="results" @id="showMonastery" @back="goToSearch"></search-results>
  </div>
</template>

<script>
import SearchForm from "../components/SearchForm";
import SearchResults from "../components/SearchResults";

export default {
  name: 'Convemos',
  components: {SearchResults, SearchForm},
  data: ()=>({
    searchInfo: {},
    //Control
    activePage: [true, false],
    results: {},
  }),
  methods:{
    showResults(values){
      this.results = values.monasteries;
      this.activePage = [false, true];
    },
    showMonastery(id){
      this.$router.push({name: 'Convent', params: {id: id, results:this.results}})
    },
    goToResults(){
      this.activePage = [false, true];
    },
    goToSearch(){
      this.activePage = [true, false];
    },
  },
  async created() {
    if(this.$route.params.results != null){
      this.results = this.$route.params.results;
      this.activePage = [false, true];
    }
  }
}
</script>

<style scoped>
</style>

